import api from "../utils/API";

const getAllProcesses = (candidat, page, limit, statut) => {
  return api.get(`/processes/candidats/${candidat}/process/list?page=${page}&limit=${limit}&statut=${statut}`);
};

const addProcess = (data) => {
  return api.post(`/processes/candidats/process/add`, data);
};

const addCandidatsInProcess = (data) => {
  return api.post(`/processes/mission/candidats/process/add`, data)
};

const sendProcess = (data) => {
  return api.post(`/process/processes/send`, data);
};

const sendEmailCandidat = (data) => {
  return api.post(`/candidat/email/send`, data, {headers: { 'Content-Type': 'multipart/form-data'}});
};

const sendEmailContact = (data) => {
  return api.post(`/contact/email/send`, data);
};

const revealProcess = (data) => {
  return api.post(`/process/processes/reveal`, data);
};

const validateProcess = (process) => {
  return api.post(`/process/processes/validate`, { process });
};

const agreementProcess = (processId) => {
  return api.put(`/process/processes/agree`, { processId });
};

const deleteProcess = (proces) => {
  return api.delete(`/process/processes/${proces}/delete`);
};

const updateProcessDate = (processId, dateType, newDate) => {
  return api.put(`/process/processes/${processId}/updateDate`, {
    processId,
    dateType,
    newDate,
  });
};

const updateProcessAttribute = (processId, attribute, value) => {
  return api.put(`/process/processes/${processId}/updateAttribute`, { attribute, value });
};


const updateProcessSourceur = (processId, sourceur) => {
  return api.put(`/process/processes/${processId}/updateAttribute`, {
    attribute: 'sourceur',
    value: sourceur ?? null,
  });
};

const updateCandidatClientMetaAttribute = (candidatId, attribute, value) => {
  return api.put(`/processes/candidats/${candidatId}/client-meta/updateAttribute`, { attribute, value });
};

const getCandidatClientMeta = (candidatId) => {
  return api.get(`/processes/candidats/${candidatId}/client-meta`);
};

const sendEmailClientMeta = (formData) =>
  api.post("/process/email/send-client-meta", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
const reactivateProcess = (processId) => {
  return api.put(`/process/processes/${processId}/reactivate`, { processId });
};
export { getAllProcesses, agreementProcess,sendEmailContact, addProcess, addCandidatsInProcess, sendProcess, revealProcess, validateProcess, deleteProcess, sendEmailCandidat, updateProcessDate, updateProcessAttribute, updateProcessSourceur, getCandidatClientMeta, updateCandidatClientMetaAttribute, sendEmailClientMeta, reactivateProcess };
